import axios from '../utils/axios';

export default function fetchSeekerVerificationList(adminId, params) {
        return (
            axios.get(`/admin/${adminId}/jobseeker-admin/user/admin/verification-status`, { params }).
            then(response => {
                return response.data;
            }).
            catch(err => {
                return err;
            })
        )   
}
